<template>
    <div class="mod mod-half mod-fbl">
        <h2><i>6</i>两市资金<span class="icon-help" v-on:click="toggle">?</span></h2>
        <div class="chart-legend">
            <span class="org">净流入：<b>{{legend.jlr}}亿</b></span>
        </div>
        <div class="chart-wrap" id="lszj-echart-container"><p class="blank">-- 暂无数据 --</p></div>
        <p class="help-pop" style="display: block" v-show="isHelp">两市资金基于大智慧主力资金（ace）估算数据，按每一笔主动性买卖单的成交额来监控上证、深证、中小板、创业板主力资金的动向。两市资金为正，则表示买入强度越大；反之则代表卖出强度越大。</p>
    </div>
</template>

<script>
    import date from '@/utils/date.js'
    import { mapState } from 'vuex'
    export default {
        data:function(){
            return {
                isHelp:false,
                error:false,
                legend:{jlr:'--'},
                chartData:{time:[],lszj:[]}
            }
        },
        computed: {
            ...mapState(['isBlankPage'])
            //this.BlankPage;
        },
        mounted:function(){
           this.handleIndicatorCalcCfdsMin();
        },
        methods: {
            toggle: function () {
                this.isHelp =! this.isHelp;
            },
            getIndicatorCalcCfdsMinSH000001:function() {
                return new Promise(function (resolve, reject){
                    dzhyun.query('/indicator/calc/cfds/min', { obj:'SH000001'}, function(data) {
                        //...
                    }).then(function(data) {
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
                //+this.token
            },
            getIndicatorCalcCfdsMinSZ399001:function() {
                return new Promise(function (resolve, reject){
                    dzhyun.query('/indicator/calc/cfds/min', { obj:'SZ399001'}, function(data) {
                        //...
                    }).then(function(data) {
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },
            handleIndicatorCalcCfdsMin:function() {
                var self=this;
                var Pro = Promise.all([self.getIndicatorCalcCfdsMinSH000001(), self.getIndicatorCalcCfdsMinSZ399001()]);
                Pro.then(function(data){
                    var sh=data[0];
                    var sz=data[1];
                    if(sh.length>0){
                        var myDate
                        var time
                        if( sh[0].ShuJu != undefined && sh[0].ShuJu.length>0){
                            for(var i=0;i<sh[0].ShuJu.length;i++){
                                if(sz[0].ShuJu!= undefined && sz[0].ShuJu[i] != undefined ){
                                    myDate     =new Date((sh[0].ShuJu[i].ShiJian)*1000);
                                    time       =date.formt(myDate,"hh:mm");
                                    if(time=="09:25" || time=="13:00"){
                                        continue;
                                    }
                                    self.chartData.time.push(time);
                                    self.chartData.lszj.push((sh[0].ShuJu[i].JieGuo[1]+sz[0].ShuJu[i].JieGuo[1]).toFixed(2));//跌停家数
                                }else{
                                    //this.chartData.lszj[i]    =this.chartData.lszj[i-1]; 不完整不显示
                                }
                            }
                            self.legend.jlr      = self.chartData.lszj[self.chartData.lszj.length - 1];
                        }
                    }
                    if(!self.isBlankPage && self.chartData.time.length>0 && self.chartData.lszj.length>0){
                        self.myChart();
                    }
                }).catch(err=>{
                        console.log(err);
                })
            },
            getMarketcapInfo:function () {
                var _this=this;
                dzhyun.query('/indicator/calcv2/marketcap', { obj:'SH000001,SZ399001',bigorder:'0' }, function(data) {
                    //...
                }).then(function(data) {
                    _this.handleGetMarketcapSucc(data);
                }).catch(function(err) {
                    //...
                });
            },

            myChart:function(){
                var self=this
                // 基于准备好的dom，初始化echarts实例
                var echart = echarts.init(document.getElementById('lszj-echart-container'),'white');
                // 指定图表的配置项和数据
                var option = {
                    backgroundColor: '#FFFFFF',
                    title: {
                        show: true,
                        textStyle: {
                            color: '#222',
                            fontSize: 12,
                            fontWeight: 'normal'
                        },
                        z: 2,
                        left: 30,
                        top: '-5px'
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#406cc2',
                        textStyle: {
                            color: "#fff",
                            fontSize: 12
                        },
                        position: function (point) {
                            // 固定在顶部
                            // return [point[0], '0'];
                        },
                        padding: [5, 10],
                        confine: true,
                        formatter: function (params) {
                            var string = '';
                            if (!isNaN(params[0].value)) {
                                string += '两市资金:' + params[0].value + '亿<br/>';
                            }
                            return (string == '') ? false : params[0].name + '<br/>' + string;
                        },
                        axisPointer: {
                            lineStyle: {color: '#406cc2'},
                        }
                    },
                    color: ['#fd8824'],
                    grid: {
                        left: 10,
                        right: 30,
                        top: 20,
                        bottom:10,
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: false
                    }],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: function(index,name){//index是x轴的坐标序号，name是坐标值
                                var timeLength=self.chartData.time.length-1;
                                var interval
                                if(timeLength<=10){
                                    if(index==0){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }else if(timeLength<=30){
                                    interval=Math.ceil(timeLength/2)
                                    if(index==interval*0){
                                        return true;
                                    }
                                    if(index==interval*1){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }else{
                                    interval=Math.ceil(timeLength/4)
                                    if(index==interval*0){
                                        return true;
                                    }
                                    if(index==(interval*1-1)){
                                        return true;
                                    }
                                    if(index==(interval*2-1)){
                                        return true;
                                    }
                                    if(index==(interval*3-1)){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }
                            },
                            textStyle: {fontSize: 13},
                            formatter: null
                        },
                        axisTick:{
                            show:false //是否显示坐标轴刻度
                        },
                        data: this.chartData.time
                    },
                    yAxis: {
                        type: 'value',
                        scale: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            margin: 2,
                            textStyle: {fontSize: 13}
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {}
                        },
                        splitNumber: 3,
                    },
                    series: [
                        {
                            name: '触及涨停',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(253, 136, 36, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: this.chartData.lszj
                        }
                    ]
                };
                echart.setOption(option);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/lszj.vue